import http from './http'

export default class HomeworkApi {
	/**
	 * 在线作业
	 * @param {*} params 参数
	 * @param {*} params.uid 用户id
	 * @param {*} params.qid 课程id
	 */
	static questionInfo(params) {
		return http.httpGet('/admin/question/info', params)
	}
	/**
	 * 获取训练营信息
	 */
	static getCourseQuick(params) {
		return http.httpGet('/admin/course/quick/getCourseQuick',params)
	}
	/**
	 * 获取客户所有作业
	 * @param {*} params
	 * @param {*} params.pageNum
	 * @param {*} params.pageSize
	 */
	static questionList(params) {
		return http.httpGet('/admin/question/list', params)
	}
	/**
	 * 提交作业
	 * @param {*} params
	 * @param {*} params.pageNum
	 * @param {*} params.pageSize
	 */
	static saveAnswer(params) {
		return http.httpPost('/admin/question/saveAnswer', params)
	}



}
